import capitalize from "lodash.capitalize";
import toLower from "lodash.tolower";

import { setUser } from "@src/utils/setUser";

import { IgStorage } from "./igStorage";

export const sleep = async (time: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

export const toProperCaseWithSpaces = (value: string) => {
  return capitalize(toLower(value.replaceAll("_", " ")));
};

export const flattenObject = (ob: object) => {
  const toReturn = {};

  Object.keys(ob).map((i) => {
    // @ts-ignore
    if (typeof ob[i] === "object" && ob[i] !== null) {
      // @ts-ignore
      const flatObject = flattenObject(ob[i]);
      Object.keys(flatObject).map((x) => {
        // @ts-ignore
        toReturn[`${i}.${x}`] = flatObject[x];
        return x;
      });
    } else {
      // @ts-ignore
      toReturn[i] = ob[i];
    }
    return i;
  });
  return toReturn;
};

export const logoutWithWorker = () => {
  let logoutWorker: SharedWorker;
  try {
    logoutWorker = new SharedWorker("./workers/logout-worker.js", {
      type: "module",
      name: "Global Logout",
    });
    logoutWorker.port.postMessage({ type: "LOG_OUT" });
  } catch (e) {
    console.log(e);
  }
};

export const Logout = () => {
  console.log("Logout Received");
  IgStorage.clearAuthTokens();
  setUser(null);
  window.location.href = "/";
};

export const hardLogout = () => {
  IgStorage.clearAll();
  logoutWithWorker();
  Logout();
};

export const getAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search);

  // ShareToken only valid on share routes (/share/*) - prevents accidental
  // auth hijacking if share_token param appears elsewhere
  const isShareRoute = window.location.pathname.startsWith("/share/");
  if (isShareRoute) {
    const shareToken = urlParams.get("share_token");
    if (shareToken && shareToken.trim().length > 0) {
      return `ShareToken ${shareToken}`;
    }
  }

  // Widget token
  if (urlParams?.has("widgetAuth")) {
    return IgStorage.widgetToken;
  }

  // Logout if session/local out of sync
  if (!IgStorage.hasSessionLocalSync()) {
    logoutWithWorker();
    return null;
  }

  // URL auth param or stored token
  return urlParams?.get("auth") || IgStorage.authToken;
};
